export default __webpack_public_path__ + "static/media/canvasAndFramedLargeCanvasFramedOak.72cec49c.jpg";